import type { shortCuts } from '~/types/shortcuts';

/**
 * Enable shortcuts passed by params
 * @param shortcuts list of shortcuts to be enabled
 */
function shortcuts(...shortcuts: shortCuts[]) {
  for (const shortcut of shortcuts) {
    makeShortcut(shortcut);
  }
}

// Event listeners
function f1Shortcut() {
  const listener = (e: KeyboardEvent) => {
    if (e.keyCode === 112) {
      alert('Teclou f1');
    }
  };

  document.addEventListener('keydown', listener);

  // Remove the event listener after use
  document.removeEventListener('keydown', listener);
}

function f2Shortcut() {
  // document.addEventListener("")
  document.addEventListener('keydown', (e: KeyboardEvent) => {
    if (e.keyCode === 113) {
      alert('teclou f2');
    }
  });
}

// Shortcuts factory
/**
 * Factory of shortcuts listeners
 * @param shortcut shortcut to be created
 */
function makeShortcut(shortcut: shortCuts) {
  if (shortcut === 'f1') {
    f1Shortcut();
  } else if (shortcut === 'f2') {
    f2Shortcut();
  }
}

export default defineNuxtPlugin(() => {
  return {
    provide: {
      enableShortcuts: shortcuts,
    },
  };
});
